import { authorisedFetch } from 'api/rest/authorisedFetch';
import { TRADERS_API_URL } from 'data/constants';
import { TraderDeposit } from 'data/traders/deposits/models/TraderDeposit';
import { parseItemStrict } from 'utils/parser/parseResponse';

export async function setDepositToPaid(depositId: string) {
  const result = await authorisedFetch(
    `${TRADERS_API_URL}/account/deposits/${depositId}/paid`,
    {
      method: 'POST',
    },
  );

  if (result.status > 399) {
    const responseBody = await result.text();
    throw new Error(`Failed to get customer payouts: ${responseBody}`);
  }

  return parseItemStrict(TraderDeposit, await result.json());
}
